import { render, staticRenderFns } from "./form-vacancy.vue?vue&type=template&id=06abfa0a&scoped=true"
import script from "./form-vacancy.vue?vue&type=script&lang=js"
export * from "./form-vacancy.vue?vue&type=script&lang=js"
import style0 from "./form-vacancy.vue?vue&type=style&index=0&id=06abfa0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06abfa0a",
  null
  
)

export default component.exports